import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LandingPage from "@/pages/LandingPage";
import TranslatePage from "@/pages/TranslatePage";
import TerminologyPage from "@/pages/TerminologyPage";
import MetricsPage from "@/pages/MetricsPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import HistoryPage from "@/pages/HistoryPage";
import SettingsPage from "@/pages/SettingsPage";
import TermsPage from "@/pages/TermsPage";
import AdminPage from "@/pages/AdminPage";
import RAGAdminPage from "@/pages/RAGAdminPage";
import FineTuningPage from "@/pages/FineTuningPage";
import SignedOutPage from "@/pages/SignedOutPage";
import APIDocsPage from "@/pages/APIDocsPage";

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-background text-foreground">
        <div className="noise-overlay" aria-hidden="true" />
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/signed-out" element={<SignedOutPage />} />
            <Route path="/docs" element={<APIDocsPage />} />
            
            {/* Protected routes - require authentication */}
            <Route path="/translate" element={
              <ProtectedRoute><TranslatePage /></ProtectedRoute>
            } />
            <Route path="/terminology" element={
              <ProtectedRoute><TerminologyPage /></ProtectedRoute>
            } />
            <Route path="/metrics" element={
              <ProtectedRoute><MetricsPage /></ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute><AnalyticsPage /></ProtectedRoute>
            } />
            <Route path="/history" element={
              <ProtectedRoute><HistoryPage /></ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute><SettingsPage /></ProtectedRoute>
            } />
            
            {/* Admin-only routes */}
            <Route path="/admin" element={
              <ProtectedRoute requireAdmin><AdminPage /></ProtectedRoute>
            } />
            <Route path="/rag-admin" element={
              <ProtectedRoute requireAdmin><RAGAdminPage /></ProtectedRoute>
            } />
            <Route path="/finetune" element={
              <ProtectedRoute requireAdmin><FineTuningPage /></ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#111111',
              border: '1px solid #27272A',
              color: '#FFFFFF',
            },
          }}
        />
      </div>
    </AuthProvider>
  );
}

export default App;
